import { render, staticRenderFns } from "./BankInformation.vue?vue&type=template&id=bef0156a&scoped=true&"
import script from "./BankInformation.vue?vue&type=script&lang=js&"
export * from "./BankInformation.vue?vue&type=script&lang=js&"
import style0 from "./BankInformation.vue?vue&type=style&index=0&id=bef0156a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef0156a",
  null
  
)

export default component.exports